import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=24a44438&"
var script = {}
import style0 from "./LoginLayout.vue?vue&type=style&index=0&id=24a44438&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports